import { getUser } from '../services/auth'

type DateValue = string | number | Date

export const formatUserDateTime = (value: DateValue, includeTime: boolean = true): string => {
  if (!value) return '-'

  try {
    let date: Date

    if (typeof value === 'string') {
      date = new Date(value)
    } else if (typeof value === 'number') {
      date = new Date(value)
    } else {
      date = value
    }

    if (isNaN(date.getTime())) {
      return '-'
    }

    // Get user preferences
    const user = getUser()
    const use24h = user?.timeFormat24h ?? false

    // Format as 'DD-MMM-YYYY HH:mm:ss' or 'DD-MMM-YYYY'
    const pad = (n: number) => n.toString().padStart(2, '0')
    const day = pad(date.getDate())
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const month = monthNames[date.getMonth()]
    const year = date.getFullYear()

    if (includeTime) {
      let timeString: string
      if (use24h) {
        // 24-hour format: HH:mm:ss
        const hours = pad(date.getHours())
        const minutes = pad(date.getMinutes())
        const seconds = pad(date.getSeconds())
        timeString = `${hours}:${minutes}:${seconds}`
      } else {
        // 12-hour format with AM/PM
        timeString = date.toLocaleTimeString('en-US', { hour12: true })
      }
      return `${day}-${month}-${year} ${timeString}`
    }
    return `${day}-${month}-${year}`
  } catch (error) {
    console.error('Error formatting date:', error)
    return '-'
  }
}

/**
 * Converts a moment date to server format (UTC timestamp)
 * Matches legacy Utils.convertDateForServer
 *
 * @param val - Moment date value
 * @param endOfDay - If true, sets time to 23:59:59, otherwise 00:00:00
 * @returns UTC timestamp or original value if not a moment
 */
export const convertDateForServer = (val: any, endOfDay: boolean = false): any => {
  if (val !== null && val.utc) {
    const utcDateAt = val.utc(true)
    utcDateAt.set(
      endOfDay
        ? { hour: 23, minute: 59, second: 59, millisecond: 0 }
        : { hour: 0, minute: 0, second: 0, millisecond: 0 }
    )
    val = utcDateAt.valueOf()
  }
  return val
}
